export const faroErrorBoundaryInitialState = {
    hasError: false,
    error: null,
};
//# sourceMappingURL=const.js.map